import React from 'react'
import HomeOpenOptinModalButton from './HomeOpenOptinModalButton'

export default function (props, state) {

  const style = {
    container: {
      fontSize: "1em",
      position: "absolute",
      zIndex: 2,
      top:"1em",
      left:"1em",
      opacity: 0.7,
      color: "#B3B8BD",
    },
    theSpan: {
      display: "block",
      fontSize: "0.6em"
    },
    bigSpan: {
      display: "block"
    },
    demoSpan: {
      display: "block",
      marginTop: "1em",
      fontSize: "0.6em"
    },
  };

  return (
    <div style={style.container}>
      <div>
        <span style={style.theSpan}>THE</span>
        <span style={style.bigSpan}>DANGER</span>
        <span style={style.bigSpan}>CREW</span>
        <span style={style.demoSpan}>BATTLE DEMO</span>
      </div>
      <div>
        <HomeOpenOptinModalButton />
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/b5-home/MenuBrandingLogo.js